<script>
import AppQrReader from "@/components/AppQrReader.vue";

export default {
  name: "BatchPage",
  components: {AppQrReader},
  data() {
    return {
      batches: [],
      queryString: "",
      lastQueryString: "",
      qr: false,
    }
  },
  async created () {
    await this.$store.dispatch('initItems', {entityName: 'batch'})
    this.resetBatches()
  },
  methods: {
    resetBatches () {
      this.batches = this.$store.state.batch.sort((a, b) => a.uniqueNumber.localeCompare(b.uniqueNumber))
    },
    searchBatch() {
      if (this.queryString === this.lastQueryString)
        return;

      const queryString = this.queryString.toLowerCase()

      if (this.queryString.length > 0)
        this.batches = this.$store.state.batch.filter( batch =>
            batch.uniqueNumber.toLowerCase().includes(queryString) ||
            (batch.number && batch.number.toString().includes(queryString)))
      else
        this.resetBatches()

      this.lastQueryString = queryString
    },
    showQrReader() {
      this.qr = true;
    },
    qrRead(params) {
      if (params.qrString) {
        this.setBagId(params.qrString)
        this.saveBagLoading()
      }
      this.qr = false
    }
  }
}
</script>

<template>
  <h1 class="mb-0">Chargen</h1>
  <ul
      class="nav mt-0">
    <li
        @click="showQrReader" class="qr">
      QR-Code
      <img src="@/assets/images/icon-qr-code.svg"/>
    </li>
  </ul>
  <form @submit.prevent="false" class="row">
    <div class="input-group col-8 mt-2 mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="queryString">Suche Nummer</label>
      </div>
      <input v-model="queryString" @keyup="searchBatch" class="form-control form-control-lg"
             id="queryString" placeholder="">
      <div class="input-group-append">
      </div>
    </div>
  </form>
  <ul class="subnav col-8 mb-0">
    <router-link
        v-for="batch in batches"
        :key="batch.batchId"
        :to="{name: 'BatchView', params: {id: batch.uniqueNumber}}">
      <li class="row">
        <label class="col-4">{{ batch.uniqueNumber + (batch.number ? '/'+ batch.number : '') }}</label>
        <div class="col-3"></div>
      </li>
    </router-link>
  </ul>

  <app-qr-reader v-if="qr" :doEmit="true" @qrRead="qrRead"/>
</template>

<style scoped>

</style>